import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";

@Injectable({
  providedIn: 'root'
})
export class ProductDashboardService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getProductData(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.PRODUCT_DASHBOARD.PRODUCT_DASHBOARD_DATA}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  postProductData(data: any): Observable<any> {
    // const data = { brand: brand, nda: nda };
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.PRODUCT_DASHBOARD.PRODUCT_DASHBOARD_DATA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getRemoveProductData(data: any): Observable<any> {
    // const data = { brand: brand, nda: nda };
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.PRODUCT_DASHBOARD.REMOVE_PRODUCT}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  RemoveProduct(data: any): Observable<any> {
    // const data = { brand: brand, nda: nda };
    return this.http.post(`${AppConstants.API_ENDPOINT}${AppConstants.API.PRODUCT_DASHBOARD.REMOVE_PRODUCT_DATA}`, data).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
